import { path } from 'ramda'

/**
 * Load the user data from Yoda.
 *
 * @return {Promise}
 * @private
 */
const loadUserData = async (getUserData, user) => {
  let userDataError = null

  const response = await getUserData(user).catch((error) => {
    userDataError = error
  })

  return { userData: path(['content'], response), userDataError }
}

export default loadUserData
